import { render, staticRenderFns } from "./NewAddOTPComponent.vue?vue&type=template&id=6c207948&scoped=true"
import script from "./NewAddOTPComponent.vue?vue&type=script&lang=js"
export * from "./NewAddOTPComponent.vue?vue&type=script&lang=js"
import style0 from "./NewAddOTPComponent.vue?vue&type=style&index=0&id=6c207948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c207948",
  null
  
)

export default component.exports